.page {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  animation: fade-up 0.55s var(--kh-ease-out) both;
}

/* ─── Section header (white text on dark red bg) ─── */

.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sectionHeader {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sectionHeader::after {
  content: "";
  flex: 1;
  height: 0.5px;
  background: rgba(255, 255, 255, 0.2);
}

.sectionLabel {
  font-family: var(--kh-font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #ffffff;
  text-transform: uppercase;
  flex-shrink: 0;
}

.topNav {
  display: flex;
  align-items: center;
  gap: 10px;
}

.backBtn,
.connectBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.18);
  border: 0.5px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition:
    background var(--kh-duration-fast),
    border-color var(--kh-duration-fast);
}

.backBtn:hover,
.connectBtn:hover {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.6);
}

/* ─── Portal list card (white surface) ─── */

.card {
  background: var(--kh-surface);
  border: 0.5px solid var(--kh-border);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-1);
  overflow: hidden;
}

.empty {
  padding: 28px 20px;
  color: var(--kh-text-muted);
  font-size: var(--kh-size-body);
  text-align: center;
  margin: 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  border-bottom: 0.5px solid var(--kh-border);
  transition: background var(--kh-duration-fast);
}

.row:last-child {
  border-bottom: none;
}

.row:hover {
  background: var(--kh-surface-2);
}

.rowMain {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.portalName {
  font-size: var(--kh-size-body);
  font-weight: 600;
  color: var(--kh-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.portalId {
  font-family: var(--kh-font-mono);
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
}

.rowMeta {
  display: flex;
  gap: 20px;
  flex-shrink: 0;
}

.metaItem {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-secondary);
  white-space: nowrap;
}

.nicknameInput {
  font-size: var(--kh-size-body);
  font-weight: 600;
  color: var(--kh-text-primary);
  background: var(--kh-surface-2);
  border: 0.5px solid var(--kh-border-hover);
  border-radius: var(--kh-radius-sm);
  padding: 4px 8px;
  width: 100%;
  outline: none;
}

.nicknameInput:focus {
  border-color: var(--kh-red);
}

.renameBtn {
  background: none;
  border: none;
  color: var(--kh-text-muted);
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  transition: color var(--kh-duration-fast);
}

.renameBtn:hover {
  color: var(--kh-text-primary);
}

.deleteBtn,
.reauthBtn {
  background: none;
  border: 0.5px solid var(--kh-border-hover);
  color: var(--kh-text-muted);
  border-radius: var(--kh-radius-sm);
  padding: 4px 10px;
  font-size: var(--kh-size-meta);
  cursor: pointer;
  flex-shrink: 0;
  text-decoration: none;
  transition:
    color var(--kh-duration-fast),
    border-color var(--kh-duration-fast);
}

.deleteBtn:hover {
  color: var(--kh-red);
  border-color: var(--kh-red);
}

.reauthBtn:hover {
  color: var(--kh-text-primary);
  border-color: var(--kh-text-primary);
}

@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
